import {
  FETCH_DEVICE_STATUS,
  FETCH_DEVICE_STATUS_SUCCESS,
  FETCH_DEVICE_STATUS_FAILURE,
} from '../actions/deviceStatus';

const INITIAL_STATE = { loading: true, data: null, error: null };

export default function deviceStatus(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_DEVICE_STATUS:
      return { ...state, loading: true, error: null };

    case FETCH_DEVICE_STATUS_SUCCESS:
      return { ...state, loading: false, data: action.payload };

    case FETCH_DEVICE_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
